import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle mb-15">
                    {this.props.t('opportunities.striking_distance.subtitle')}
                </div>
            </>
        );
    }
}

export default ExtraButtons;
